import React, { useState, useEffect } from "react";
import {
    TextField,
    Typography,
    Box,
    Grid,
    Avatar,
    IconButton,
    FormControlLabel,
    Switch,
    MenuItem,
    Button
} from '@mui/material';
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MusicPlayer from '../CardView/CardMusicPlayer';

const DesignContentPage6 = ({ data }) => {

    return (
        <Box
            sx={{
                padding: '20px',
                fontFamily: data.fontStyle,
                textAlign: 'start',
                display: 'flex',
                flexDirection: 'column',
                '& .music-player': {
                    position: 'absolute',
                    top: '10px',
                    left: '50%',
                    transform: 'translateX(-50%) scale(0.8)',
                    zIndex: 10
                }
            }}
        >

            <MusicPlayer data={data} playOnOpen={true} isPreviewMode={true} />

            <Box sx={{ mt: 6, px: 2, pt: 3, pb: 3, border: '1px solid #ddd', borderRadius: '20px', background: '#fff' }}>

                {data.contactDetails?.map((p, index) => (

                    <Grid
                        key={index}
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                            mt: 2,
                            background: "#f0f0f0ff",
                            borderRadius: "20px",
                            p: 1.5,
                            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                        }}
                    >



                        {/* Left side - Avatar + Name */}
                        <Grid item sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                            <Avatar size sx={{ bgcolor: data.themeColour || "#333", width: 30, height: 30 }} />
                            <Box>
                                <Typography sx={{ fontWeight: 600, fontSize: "12px" }}>{p.contactName || "Nama"}</Typography>
                                <Typography variant="body2" sx={{ color: "#888", fontSize: "12px" }}>
                                    ({p.relationship || 'Hubungan'})
                                </Typography>
                            </Box>
                        </Grid>

                        {/* Right side - Icons */}
                        <Grid item sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <IconButton
                                disableRipple
                                sx={{
                                    width: 30,
                                    height: 30,
                                    background: data.themeColour || "#333",
                                    color: "#fff",
                                }}
                            >
                                <PhoneIcon sx={{ fontSize: 19 }} />
                            </IconButton>
                            <IconButton
                                disableRipple
                                sx={{
                                    width: 30,
                                    height: 30,
                                    background: data.themeColour || "#333",
                                    color: "#fff",

                                }}
                            >
                                <WhatsAppIcon fontSize="small" />
                            </IconButton>
                        </Grid>

                    </Grid>
                ))}
            </Box>

        </Box>

    )
};

export default DesignContentPage6